<template>
  <ul class="tabs">
    <li
      class="tab"
      v-for="(item, index) in data"
      :key="index"
      :class="{ 'tab--active': activeTab === index }"
      @click="changeTab(index)"
    >
      {{ item.name }}
    </li>
  </ul>
</template>

<script>
export default {
  name: 'BaseTabs',
  props: {
    data: Array
  },
  data() {
    return {
      activeTab: 0
    }
  },
  methods: {
    changeTab(index) {
      this.activeTab = index

      this.$emit('change', index)
    }
  }
}
</script>

<style lang="scss" scoped>
.tabs {
  margin-top: 30px;
  line-height: 40px;
  font-size: 16px;
  font-weight: bold;
  color: #262626;
  text-align: center;
  border-bottom: 1px solid #ebebeb;
  display: flex;

  .tab {
    width: 98px;
    cursor: pointer;
  }

  .tab--active {
    position: relative;
    color: #046bcc;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 34px;
      height: 4px;
      background-color: #046bcc;
    }
  }
}
</style>
